import ListItem, { type ListItemProps } from '@mui/material/ListItem';
import List, { type ListProps } from '@mui/material/List';
import React from 'react';
import { styled, useThemeProps } from '@mui/material/styles';
import { generateUtilityClasses } from '@mui/material';
import clsx from 'clsx';

export type OrderedListProps = ListProps;
export type OrderedListItemProps = ListItemProps;

const orderedListClassName = 'MuiOrderedList';
const orderedListItemClassName = 'MuiOrderedListItem';
export const orderedListClasses = generateUtilityClasses(orderedListClassName, ['root']);
export const orderedListItemClasses = generateUtilityClasses(orderedListItemClassName, ['root']);

const OrderedListThemed = styled(List, {
    name: orderedListClassName,
    slot: 'Root',
    overridesResolver: (props, styles) => styles.root,
})(() => ({}));

const OrderedListItemThemed = styled(ListItem, {
    name: orderedListItemClassName,
    slot: 'Root',
    overridesResolver: (props, styles) => styles.root,
})(() => ({
    // Workaround for some legacy styles
    '::before': { display: 'none' },
}));

export const OrderedList = React.forwardRef<HTMLUListElement, OrderedListProps>(function (inProps, ref) {
    const props = useThemeProps({ props: inProps, name: orderedListClassName });
    return <OrderedListThemed ref={ref} {...props} className={clsx(props.className, orderedListClasses.root)} />;
});

OrderedList.displayName = 'OrderedList';

export const OrderedListItem = React.forwardRef<HTMLLIElement, OrderedListItemProps>(function (inProps, ref) {
    const props = useThemeProps({ props: inProps, name: orderedListItemClassName });
    return (
        <OrderedListItemThemed ref={ref} {...props} className={clsx(props.className, orderedListItemClasses.root)} />
    );
});

OrderedListItem.displayName = 'OrderedListItem';
